import type { Banner } from 'api/banner';

const filterBannersList = (banners: Banner[], isLoggedIn: boolean): Banner[] =>
  banners.filter(
    (banner) =>
      banner.user_visibility === 'public' ||
      (banner.user_visibility === 'registered' && isLoggedIn) ||
      (banner.user_visibility === 'anonymous' && !isLoggedIn),
  );

export default filterBannersList;
